import {
  SIGN_UP_REQUEST,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  GET_LETTER_PLANS_REQUEST,
  GET_LETTER_PLANS_SUCCESS,
  GET_LETTER_PLANS_FAILURE,
  POST_IP_CHECK_SUCCESS,
  POST_IP_CHECK_FAILURE,
  POST_IP_CHECK_REQUEST,
} from '../../constants/ActionTypes'

const initialState = {
  registering: false,
  error: {},
  letterPlans: [],
  isLoading: false,
  ipCheck: false,
  ipCheckLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_UP_REQUEST:
      return {
        ...state,
        error: {},
        registering: true,
      }
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        registering: false,
        error: {}
      };
    case SIGN_UP_FAILURE: {
      let error = {};
      error = { ...action.payload.error.message };
      return {
        ...state,
        registering: false,
        error: error,
      }
    }
    case GET_LETTER_PLANS_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case GET_LETTER_PLANS_SUCCESS:
      return {
        ...state,
        letterPlans: action.payload.plans.filter(plan => plan.is_user_display === 1),
        isLoading: false,
      }
    case GET_LETTER_PLANS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      }
    case POST_IP_CHECK_REQUEST:
      return {
        ...state,
        ipCheck: false,
        ipCheckLoading: true,
      }
    case POST_IP_CHECK_SUCCESS:
      return {
        ...state,
        ipCheck: action.payload.enabled,
        ipCheckLoading: false,
      }
    case POST_IP_CHECK_FAILURE:
      return {
        ...state,
        ipCheck: false,
        ipCheckLoading: false,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/signup.js